import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { Grid2, Typography } from '@mui/material';
import { ViewMode } from './types';
import strings from 'constants/strings';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { OpUnitType } from 'dayjs';
import { useMedicalView } from 'utils/MedicalViewProvider';

export const DateSelector: FunctionComponent = () => {
  const { viewMode, selectedDate, setSelectedDate, isLeftMenuOpen } =
    useMedicalView();

  const displayDate = useMemo(() => {
    switch (viewMode) {
      case ViewMode.month:
        return dayjs(selectedDate, 'YYYY-MM-DD').format(
          strings.general.date.full_date_month,
        );
      case ViewMode.week: {
        const startOfWeek = dayjs(selectedDate, 'YYYY-MM-DD')
          .startOf('week')
          .format(strings.general.date.full_date_week_range_start);
        const endOfWeek = dayjs(selectedDate, 'YYYY-MM-DD')
          .endOf('week')
          .format(strings.general.date.full_date_week_range_end);
        return `${startOfWeek} - ${endOfWeek}`;
      }
      case ViewMode.day:
      default:
        return dayjs(selectedDate, 'YYYY-MM-DD').format(
          strings.general.date.full_date_day,
        );
    }
  }, [viewMode, selectedDate]);

  const refreshAppointmentByDate = (newDate: string) => {
    // medicalCareStore.initAppointmentList(newDate);
    setSelectedDate(newDate);
  };

  const handleLast = () => {
    let unit: OpUnitType = 'day';
    switch (viewMode) {
      case ViewMode.month:
        unit = 'month';
        break;
      case ViewMode.week:
        unit = 'week';
        break;
      case ViewMode.day:
      default:
        unit = 'day';
        break;
    }

    const res = dayjs(selectedDate, 'YYYY-MM-DD')
      .subtract(1, unit)
      .format('YYYY-MM-DD');
    refreshAppointmentByDate(res);
  };

  const handleNext = () => {
    let unit: OpUnitType = 'day';
    switch (viewMode) {
      case ViewMode.month:
        unit = 'month';
        break;
      case ViewMode.week:
        unit = 'week';
        break;
      case ViewMode.day:
      default:
        unit = 'day';
        break;
    }

    const res = dayjs(selectedDate, 'YYYY-MM-DD')
      .add(1, unit)
      .format('YYYY-MM-DD');
    refreshAppointmentByDate(res);
  };

  return (
    <Grid2
      container
      justifyContent="center"
      alignItems="center"
      className={'flex flexCenterCenter flexRow p8'}
      style={{ height: 72, marginLeft: isLeftMenuOpen ? 72 : 0 }}
    >
      <LeftOutlined
        className={'cursorPointer mr16 font--16 color--c-icon'}
        onClick={handleLast}
      />
      <Typography className={'color--c-black font--22 fontWeight--600'}>
        {displayDate}
      </Typography>
      <RightOutlined
        className={'cursorPointer ml16 font--16 color--c-icon'}
        onClick={handleNext}
      />
    </Grid2>
  );
};
